import { useCallback, useEffect, useState } from 'react';
import supabase from '../../supabase/supabase';

const SETTINGS_TABLE = 'platform_settings_1786725966147';

export default function usePlatformSettings() {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const fetchSettings = useCallback(async () => {
    const { data, error: fetchError } = await supabase
      .from(SETTINGS_TABLE)
      .select('*')
      .eq('id', 1)
      .single();

    if (fetchError) {
      console.error('Error fetching settings:', fetchError);
      setError('No se pudo cargar la configuración de la plataforma.');
    } else {
      setSettings(data);
      setError('');
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    fetchSettings();
    const channelId = `platform_settings_${Math.random().toString(36).substring(2, 9)}`;
    const channel = supabase
      .channel(channelId)
      .on(
        'postgres_changes',
        { event: 'UPDATE', schema: 'public', table: SETTINGS_TABLE },
        (payload) => {
          setSettings(payload.new);
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, [fetchSettings]);

  const updateSettings = async (newSettings) => {
    const { error: updateError } = await supabase
      .from(SETTINGS_TABLE)
      .update({ ...newSettings, updated_at: new Date().toISOString() })
      .eq('id', 1);

    if (updateError) {
      throw new Error(updateError.message);
    }
  };

  return { settings, loading, error, updateSettings };
}